const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/components/metakat/Versicherung/ZimmerBuchenField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';
import { TextInput } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

interface Props {
    label: TextInput;
    path: string;
    coverage: 'allgemein' | 'halbPrivat';
    hidden?: boolean;
    required?: boolean;
}

const ICODE_ZIMMERBUCHEN_HALBPRIVAT = 'bc0d0d8a-5f6a-4e78-a4f1-622ab32f66f3';
const ICODE_ZIMMERBUCHEN_ALLGEMEIN = '5131c31e-e964-466b-b561-23fc548bbe3d';

export const ZimmerBuchenField = forwardRef((props: Props, ref: any) => {
    const dropdownRef = useCIS4m(ref);
    const { locale } = useIntl();

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    const pcode = props.coverage === 'halbPrivat' ? ICODE_ZIMMERBUCHEN_HALBPRIVAT : ICODE_ZIMMERBUCHEN_ALLGEMEIN;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={props.label}
            path={props.path}
            pcode={pcode}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

ZimmerBuchenField.displayName = 'ZimmerBuchenField';
